export default __webpack_public_path__ + "static/media/powered_by_stripe.5b4e931c.svg";